import { z } from "zod";
import { useRealm } from "~/util/Lang";
import { $API, $LOADER, $PAGE, $SERVER, callApi } from "~/util/Loaders";

const testApi = $API({
  path: "test-api",
  method: "POST",
  parser: z.object({ a: z.number() }),
})(
  $SERVER?.(async (cx) => {
    return { t: "error", error: "huy" };
    return { value: "number " + cx.input.a, realm: cx.realm };
  })
);

$PAGE({
  path: "new-page",

  loader: $LOADER?.(async () => {
    return {
      id: 1,
      name: "New Page",
    };
  }),

  meta: (args) => {
    return {
      title: "Title: " + args.data.name,
    };
  },

  render: ({ data }) => {
    const realm = useRealm();

    return (
      <div>
        Name: {data.name}
        <button
          onClick={async () => {
            const result = await callApi(testApi, { input: { a: 100 }, realm });
            console.log(result);
          }}
        >
          Call API
        </button>
      </div>
    );
  },
});
